import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  "Hidden dwell patterns",
  "Empty-mile accumulation",
  "Load-planning failure",
  "Poor trailer utilization",
  "Forecasting distortion",
  "EDI/API visibility gaps",
  "Misclassified cost",
  "Vendor scheduling friction",
  "Private fleet inefficiency",
  "Cost-to-serve leakage",
];

export default function WhatAxiomFinds() {
  const { ref, visible } = useReveal();

  return (
    <section
      id="findings"
      ref={ref}
      data-testid="findings-section"
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-fine opacity-50 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-5">
              <span className="num-label">SECTION 06 / DIAGNOSTIC SCAN</span>
              <div className="flex-1 h-px bg-white/10" />
            </div>
            <h2
              data-testid="findings-headline"
              className={`font-display font-bold text-axiom-text tracking-tight text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] reveal max-w-3xl ${
                visible ? "in" : ""
              }`}
            >
              What Axiom-AI Finds <br />
              <span className="text-axiom-muted">Before It Becomes Obvious.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 font-mono text-xs text-axiom-muted">
            <span className="signal-dot animate-pulse-signal" />
            <span>SCAN.ACTIVE / 10 SIGNAL CHANNELS</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((item, i) => (
            <div
              key={item}
              data-testid={`finding-${i + 1}`}
              className={`bg-axiom-bg p-5 md:p-6 hover:bg-axiom-surface transition-colors duration-300 group relative reveal ${
                visible ? "in" : ""
              }`}
              style={{ transitionDelay: `${80 + i * 50}ms`, minHeight: 160 }}
            >
              <div className="flex items-center justify-between">
                <span className="num-label">CH.{String(i + 1).padStart(2, "0")}</span>
                <span
                  className="signal-dot opacity-40 group-hover:opacity-100 transition-opacity"
                  style={{ width: 6, height: 6 }}
                />
              </div>
              <div className="mt-8 font-display text-lg text-axiom-text font-medium leading-snug">
                {item}
              </div>
              <div className="mt-4 h-px w-8 bg-axiom-accent/40 group-hover:w-16 transition-all duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
